var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('business-hours',{class:{disabled: _vm.disabled},attrs:{"type":"select","color":"#008000","days":_vm.data,"localization":_vm.$t('businessHour'),"hourFormat24":_vm.$t('businessHour.format24h') === 'true'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }